exports = module.exports = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawer-container[data-v-126b135a] {\n  padding: 24px;\n  font-size: 14px;\n  line-height: 1.5;\n  word-wrap: break-word;\n}\n.drawer-container .drawer-title[data-v-126b135a] {\n    margin-bottom: 12px;\n    color: rgba(0, 0, 0, 0.85);\n    font-size: 14px;\n    line-height: 22px;\n}\n.drawer-container .drawer-item[data-v-126b135a] {\n    color: rgba(0, 0, 0, 0.65);\n    font-size: 14px;\n    padding: 12px 0;\n}\n.drawer-container .drawer-switch[data-v-126b135a] {\n    float: right;\n}\n", ""]);

// exports
